import React from "react";
import "../spinner2.css";

export default function LoadingSpinner() {
  return (
    <div className="bankSpinner">
        {/* <span>Loading...</span> */}
    <div className="half-spinner2"></div>
    </div>
  );
}